import React, { useEffect, useState } from "react";
import { Line } from "react-chartjs-2";
import {
  Chart as ChartJS,
  LineElement,
  CategoryScale,
  LinearScale,
  PointElement,
  Tooltip,
  Legend,
} from "chart.js";


ChartJS.register(LineElement, CategoryScale, LinearScale, PointElement, Tooltip, Legend);

const getColorForBrand = (brand) => {
  const colorMap = {
    Sleepwell: "#e74c3c",
    Wakefit: "#3498db",
    "Kurl-On": "#2ecc71",
    duroflex: "#9b59b6",
    Sleepyhead: "#f39c12",
    SleepyCat: "#1abc9c",
  };
  return colorMap[brand] || "#95a5a6";
};

const ChartComponent = ({ materialData }) => {
  const [chartData, setChartData] = useState(null);
  const [groupMeta, setGroupMeta] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!materialData || !materialData || typeof materialData !== 'object') {
      setError("No valid data provided.");
      return;
    }

    const raw = materialData;
    const combinedLabels = [];
    const datasetsMap = {};
    const groupLabels = [];
    const groupSizes = [];

    Object.keys(raw).forEach((category) => {
      const items = raw[category];
      if (!Array.isArray(items)) return;

      groupLabels.push(category);
      groupSizes.push(items.length);

      items.forEach((entry) => {
        combinedLabels.push(`${category} - ${entry.size}`);

        Object.keys(entry).forEach((brand) => {
          if (brand === "size") return;

          if (!datasetsMap[brand]) {
            datasetsMap[brand] = [];
          }

          datasetsMap[brand].push(entry[brand]);
        });

        // For missing brands, push null for alignment
        Object.keys(datasetsMap).forEach((brand) => {
          if (!(brand in entry)) {
            datasetsMap[brand].push(null);
          }
        });
      });
    });

    const datasets = Object.keys(datasetsMap).map((brand) => ({
      label: brand,
      data: datasetsMap[brand],
      borderColor: getColorForBrand(brand),
      fill: false,
    }));

    setChartData({
      labels: combinedLabels,
      datasets,
    });

    setGroupMeta({ groupLabels, groupSizes });
    setError(null);
  }, [materialData]);

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    scales: {
      x: {
        ticks: {
          maxRotation: 90,
          minRotation: 45,
          autoSkip: false,
        },
        grid: {
          display: false,
        },
      },
      y: {
        title: {
          display: true,
          text: "Difference %",
        },
      },
    },
    plugins: {
      legend: {
        display: true,
        position: "top",
      },
    },
  };

  const renderGroupLabels = () => {
    if (!groupMeta?.groupLabels?.length) return null;

    return (
      <div style={{ display: "flex", width: "100%", height: "30px", marginTop: 10 }}>
        {groupMeta.groupLabels.map((group, i) => (
          <div
            key={i}
            style={{
              flex: groupMeta.groupSizes[i],
              backgroundColor: "#34495e",
              color: "white",
              textAlign: "center",
              lineHeight: "30px",
              fontWeight: "bold",
              fontSize: 12,
              borderRight: "1px solid white",
            }}
          >
            {group}
          </div>
        ))}
      </div>
    );
  };

  return (
    <div>
      {error ? (
        <div style={{ color: "red", textAlign: "center", padding: 20 }}>
          ⚠️ {error}
        </div>
      ) : (
        <>
          <div style={{ width: "100%", height: 400 }}>
            {chartData && <Line data={chartData} options={options} />}
          </div>
          {renderGroupLabels()}
        </>
      )}
    </div>
  );
};

export default ChartComponent;
